import type { IProjectRole } from 'src/types/project-role';

/**
 * Returns the unique project role that would be duplicated if `inspectorId`
 * were assigned `projectRoleId`, given the current role map for the activity.
 */
export function findConflictingUniqueProjectRole(
  inspectorId: number,
  projectRoleId: number | undefined,
  inspectorProjectRoles: Map<number, number | undefined>,
  projectRoles: IProjectRole[]
): IProjectRole | undefined {
  if (projectRoleId == null) {
    return undefined;
  }

  const role = projectRoles.find((projectRole) => projectRole.id === projectRoleId);
  if (!role?.isUnique) {
    return undefined;
  }

  for (const [otherInspectorId, otherRoleId] of Array.from(inspectorProjectRoles)) {
    if (otherInspectorId !== inspectorId && otherRoleId === projectRoleId) {
      return role;
    }
  }

  return undefined;
}

/** Unique role ids already held by another selected inspector. */
export function getConsumedUniqueProjectRoleIds(
  inspectorId: number,
  inspectorProjectRoles: Map<number, number | undefined>,
  projectRoles: IProjectRole[]
): Set<number> {
  const uniqueRoleIds = new Set(
    projectRoles.filter((role) => role.isUnique).map((role) => role.id)
  );
  const consumed = new Set<number>();

  inspectorProjectRoles.forEach((roleId, otherInspectorId) => {
    if (
      otherInspectorId !== inspectorId &&
      roleId != null &&
      uniqueRoleIds.has(roleId)
    ) {
      consumed.add(roleId);
    }
  });

  return consumed;
}
